import React, { useState, useEffect, useRef } from "react";

const ParallaxImage = ({
    children,
    className,
    parallaxIntensity = 100,
    slideDirection = "right",
    startFromZero = false,
}) => {
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                const rect = containerRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Проверяем, находится ли элемент в пределах видимости
                if (rect.top < windowHeight && rect.bottom > 0) {
                    // Вычисляем смещение на основе позиции элемента относительно центра экрана
                    const elementCenterY = rect.top + rect.height / 2;
                    const viewportCenterY = windowHeight / 2;
                    const distanceToCenter = elementCenterY - viewportCenterY;

                    // Нормируем расстояние и применяем parallaxIntensity
                    const maxDistance = windowHeight / 2;
                    const normalizedDistance = distanceToCenter / maxDistance;
                    let offsetX = 0;
                    let offsetY = 0;

                    if (slideDirection === "right") {
                        offsetX =
                            normalizedDistance * parallaxIntensity > 0 &&
                            startFromZero
                                ? 0
                                : normalizedDistance * parallaxIntensity;
                        offsetY = 0;
                    } else if (slideDirection === "left") {
                        offsetX =
                            -normalizedDistance * parallaxIntensity < 0 &&
                            startFromZero
                                ? 0
                                : -normalizedDistance * parallaxIntensity;
                        offsetY = 0;
                    } else if (slideDirection === "up") {
                        offsetX = 0;
                        offsetY = -normalizedDistance * parallaxIntensity;
                    } else if (slideDirection === "down") {
                        offsetX = 0;
                        offsetY = normalizedDistance * parallaxIntensity;
                    }

                    setOffset({ x: offsetX, y: offsetY });
                } else {
                    // Сбрасываем смещение, когда элемент вне зоны видимости
                    setOffset({ x: 0, y: 0 });
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Вызываем при монтировании для установки начального положения

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parallaxIntensity, slideDirection]);

    const combinedClasses = `relative overflow-visible w-full h-full rounded-xl ${className}`;

    return (
        <div ref={containerRef} className={combinedClasses}>
            {/* Используем children вместо жестко закодированного img */}
            {React.cloneElement(children, {
                style: {
                    ...children.props.style, // Сохраняем любые существующие стили
                    transform: `translate(${offset.x}px, ${offset.y}px)`,
                    transition: "transform 0.3s ease-out",
                },
                className: `${children.props.className} absolute inset-0 w-full h-full`, // Добавляем абсолютное позиционирование
            })}
            {/* Опциональное градиентное затемнение */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent rounded-xl" />
        </div>
    );
};

export default ParallaxImage;
